"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ChatRead = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ChatRead_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.894.808a.5.5 0 0 0-.788-.616l-2.78 3.558-1.475-1.452a.5.5 0 0 0-.702.712l1.875 1.846a.5.5 0 0 0 .745-.048l3.125-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.541 1.5H2.75A1.75 1.75 0 0 0 1 3.25v6.002c0 .965.784 1.75 1.75 1.75.69 0 1.25.56 1.25 1.25v1.79l2.016-2.015a3.501 3.501 0 0 1 2.475-1.025h4.759A1.75 1.75 0 0 0 15 9.252V3.575l.881-1.128c.078.254.119.523.119.802v6.002a2.75 2.75 0 0 1-2.75 2.75H8.49a2.5 2.5 0 0 0-1.767.732l-2.87 2.87A.5.5 0 0 1 3 15.25v-2.998a.25.25 0 0 0-.25-.25A2.75 2.75 0 0 1 0 9.252V3.25A2.75 2.75 0 0 1 2.75.5h7.75l-.959 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ChatRead_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ChatRead;
exports["default"] = _default;